import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import CheckoutPage from './pages/CheckoutPage';

const PayoutSimulatorPage = lazy(() => import('./pages/PayoutSimulatorPage'));

/**
 * Main App Component
 * Handles routing for the checkout application
 */
function App() {
  return (
    <Routes>
      <Route path="/checkout/:token" element={<CheckoutPage />} />
      <Route
        path="/payout-simulator/:token"
        element={(
          <Suspense fallback={<div className="min-h-screen bg-slate-50 p-8 text-center text-slate-700">Loading...</div>}>
            <PayoutSimulatorPage />
          </Suspense>
        )}
      />
    </Routes>
  );
}

export default App;
